/**
 * Social component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import github from '../images/github.svg' 
import linkedin from '../images/linkedin.svg'
import twitter from '../images/twitter.svg'

const Social = () => {
  const data = useStaticQuery(graphql`
    query SocialQuery {
      site {
        siteMetadata {
          social {
            twitter
            linkedin
            github
          }
        }
      }
    }
  `)

  const { social } = data.site.siteMetadata
  return (
    <div className='social-container'>
      <a href={`https://twitter.com/${social.twitter}`} className='social-link'>
        <img src={twitter} className='social-svg'/>
      </a>
      <a href={`https://www.linkedin.com/in/${social.linkedin}`} className='social-link'>
        <img src={linkedin} className='social-svg'/>
      </a>
      <a href={`https://www.github.com/${social.github}`} className='social-link'>
        <img src={github} className='social-svg'/>
      </a>
      <a href='mailto:lenvingonsalves@gmail.com'>
        lenvingonsalves@gmail.com
      </a>
    </div>
  )
}

export default Social
